import React from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';

/*
 *   Popper Component (Menu Container)
 *   Usage/s:
 *     Outer container of menu drop downs that do not hide scroll bar
 * */
const CustomPopper = ({ open, anchorRef, handleClose, closeOnQuery, children }) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const mobileView = closeOnQuery ? useMediaQuery(closeOnQuery) : false;
  let properDisplay = 'block';

  if (closeOnQuery) if (mobileView) properDisplay = 'none';

  return (
    <Popper
      style={{ display: properDisplay, zIndex: 10 }}
      open={open}
      anchorEl={anchorRef.current}
      role={undefined}
      transition
      disablePortal
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
          }}
        >
          <Paper>
            <ClickAwayListener onClickAway={handleClose}>{children}</ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
};

export default CustomPopper;
